import * as requestFromServer from "./investigationsCrud";
import { callTypes, investigationsSlice } from "./investigationsSlice";

const { actions } = investigationsSlice;

export const fetchInvestigations = (queryParams) => (dispatch) => {
    dispatch(actions.startCall({ callType: callTypes.list }));

    return requestFromServer
        .FindInvestigations(queryParams)
        .then((response) => {
            const { totalCount, entities } = response.data;
            dispatch(actions.investigationsFetched({ totalCount, entities }));
        })
        .catch((error) => {
            error.clientMessage = "رکورد های درخواستی یافت نشد.";
            dispatch(actions.catchError({ error, callType: callTypes.list }));
        });
};

export const fetchInvestigation = (id) => (dispatch) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    return requestFromServer
        .GetInvestigationById(id)
        .then((response) => {
            const investigation = response.data;
            dispatch(
                actions.investigationFetched({ investigationToView: investigation })
            );
        })
        .catch((error) => {
            error.clientMessage = "بازرسی درخواستی یافت نشد";
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};

export const createInvestigation = (investigationForCreation) => (dispatch) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    return requestFromServer
        .CreateInvestigation(investigationForCreation)
        .then((response) => {
            const investigation = response.data;
            dispatch(actions.investigationCreated({ investigation }));
        })
        .catch((error) => {
            error.clientMessage = "خطایی هنگام ایجاد بازرسی رخ داد";
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};

export const updateInvestigation = (investigationForCreation) => (dispatch) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    return requestFromServer
        .UpdateInvestigation(investigationForCreation)
        .then((response) => {
            const investigation = response.data;
            dispatch(actions.investigationFetched({ investigation }));
        })
        .catch((error) => {
            error.clientMessage = "خطایی هنگام تغییر بازرسی رخ داد";
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};

export const deleteInvestigation = id => dispatch => {
    dispatch(actions.startCall({ callType: callTypes.action }));
    return requestFromServer
        .DeleteInvestigation(id)
        .then(() => {
            dispatch(actions.investigationDeleted(id));
        })
        .catch((error) => {
            error.clientMessage = 'خطایی هنگام پاک کردن بازرسی رخ داد.';
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        })
}